import { render, staticRenderFns } from "./admin-group.vue?vue&type=template&id=6eb87ad0"
import script from "./admin-group.vue?vue&type=script&lang=js"
export * from "./admin-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports